import { NavLink, Outlet } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";
import StudentService from "../../../services/student/StudentService";
import AuthenticatedComponent from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import ContactUsLink from "../../shared/contact-us/ContactUs";
import Nav from "../../shared/nav-menu/Nav";
import './DefaultLayout.scss';
import DefaultLayoutState, { DefaultLayoutHeaderType, DefaultLayoutProps } from "./DefaultLayout.models";

export default class DefaultLayout extends AuthenticatedComponent<DefaultLayoutProps, DefaultLayoutState> {
    studentService: StudentService;

    constructor(props: any) {
        super(props);
        this.state = {
            userInformation: {
                education: {},
                personal: {},
                system: {},
            },
            showContactUs: true
        };
        this.studentService = new StudentService();
    }

    getData = () => {
        let self = this;

        self.studentService.getStudentInformation().then(function (response) {
            if (response === undefined || response.status === 401) {
                localStorage.removeItem("access_token");
                window.location.href = "/Login";
            }
            else if (response.status === 200)
                self.setState({ userInformation: response.data });
        });
    }

    componentDidMount = () => {
        let self = this;

        this.setState({ showContactUs: this.props.showContactUs ?? true })
        self.getData()
    }

    render = () => {
        let showFooter = this.props.showFooter ?? false;
        let showDefaultHeader = this.props.showDefaultHeader ?? DefaultLayoutHeaderType.redirect;
        let { backUri, backIcon, title } = this.props;
        let { showContactUs } = this.state;

        return (
            <>
                <div className="page default-layout-area">
                    <div className="main">
                        <div className="header px-12">
                            <div className="title-loc">
                                <label>{title ?? "برنده ساز"}</label>
                            </div>
                            {this.headerView(showDefaultHeader, backUri ?? "/Dashboard", backIcon ?? "mdi-arrow-left")}
                        </div>
                        <div className="content-menu  content-area px-4">
                            <AuthContext.Provider value={{ isAuthenticated: false, userInformation: this.state.userInformation, hasContactUs: true, pageUri: '' }}>
                                {showContactUs ? <ContactUsLink /> : <></>}
                                <Outlet />
                                {this.footerView(showFooter)}
                            </AuthContext.Provider>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    headerView(show: DefaultLayoutHeaderType, redirectUri: string, redirectorIcon: string) {
        let content;

        let defaultContent = (<div className="main-menu">
            <NavLink to={"/UserProfile"}>
                <label className="mdi mdi-account-circle f-26" ></label>
            </NavLink>
            <NavLink to={"/Rewards"}>
                <label className="mdi mdi-gift f-26"></label>
            </NavLink>
        </div>);

        switch (show) {
            case DefaultLayoutHeaderType.showDefaultHeader:
                content = defaultContent;
                break;
            case DefaultLayoutHeaderType.redirect:
                content = (<>
                    <div className="main-menu">
                        <NavLink to={redirectUri} className="pd-top-8">
                            <label className={"mdi f-26 " + (redirectorIcon)} ></label>
                        </NavLink>
                    </div>
                </>);
                break;
            case DefaultLayoutHeaderType.none:
                content = (<></>);
                break;
            default:
                content = defaultContent;
                break;
        };

        return (<>{content}</>);
    }

    footerView(show: boolean) {

        let content;
        if (show)
            content = (<div className="footer">
                <Nav />
            </div>);
        else
            content = (<></>);

        return (<>
            {content}
        </>);
    }
}